import React from 'react';
import { Dialog, Checkbox, Button } from 'tdesign-react';
import '../../style/DocExtractWelcomeDialog.css';

const STORAGE_KEY = 'doc_extract_multi_welcome_dismissed';

export function shouldShowWelcomeDialog() {
  try {
    return localStorage.getItem(STORAGE_KEY) !== 'true';
  } catch {
    return true;
  }
}

/**
 * 文档抽取（多模态版）欢迎引导弹窗
 * @param {boolean} visible - 是否显示
 * @param {function} onClose - 关闭回调
 */
function DocExtractWelcomeDialog({ visible, onClose }) {
  const handleNoRemind = () => {
    try {
      localStorage.setItem(STORAGE_KEY, 'true');
    } catch {
      // ignore
    }
    onClose();
  };

  const handleStart = () => {
    onClose();
  };

  return (
    <Dialog
      visible={visible}
      onClose={handleStart}
      footer={false}
      header={false}
      width={520}
      body={false}
      style={{ padding: 0 }}
      className="t-dialog--doc-extract-welcome"
      destroyOnClose
    >
      <div className="doc-extract-welcome-header">
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
          <span style={{ background: 'rgba(255,255,255,0.25)', color: '#fff', fontSize: '11px', padding: '2px 8px', borderRadius: '4px', fontWeight: 600 }}>NEW · 字段自定义增强</span>
        </div>
        <h2 style={{ color: '#fff', fontSize: '20px', fontWeight: 700, margin: '0 0 6px' }}>欢迎使用 文档抽取（多模态版）</h2>
        <p style={{ color: 'rgba(255,255,255,0.85)', fontSize: '13px', margin: 0, lineHeight: '1.6' }}>
          在多模态识别能力之上，现已支持自定义字段与逐字段提示词，让抽取更精准、更贴合你的业务。
        </p>
      </div>

      <div style={{ padding: '20px 24px' }}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px', marginBottom: '24px' }}>
          <div style={{ display: 'flex', gap: '12px', alignItems: 'flex-start' }}>
            <div style={{ width: '36px', height: '36px', borderRadius: '8px', background: '#f0f4ff', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
              <span style={{ fontSize: '18px' }}>📋</span>
            </div>
            <div>
              <div style={{ fontWeight: 600, fontSize: '14px', color: '#1a1a1a', marginBottom: '2px' }}>选择配置模版</div>
              <div style={{ fontSize: '12px', color: '#666', lineHeight: '1.5' }}>「通用场景」按照模型理解抽取所有 KV 内容；选择货运合同、增值税发票等业务模板会自动填充对应的表格字段。</div>
            </div>
          </div>

          <div style={{ display: 'flex', gap: '12px', alignItems: 'flex-start' }}>
            <div style={{ width: '36px', height: '36px', borderRadius: '8px', background: '#f0f4ff', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
              <span style={{ fontSize: '18px' }}>✏️</span>
            </div>
            <div>
              <div style={{ fontWeight: 600, fontSize: '14px', color: '#1a1a1a', marginBottom: '2px' }}>自定义字段</div>
              <div style={{ fontSize: '12px', color: '#666', lineHeight: '1.5' }}>通过「默认key / 自定义key / 表格key」按需增删文本字段（KV）与表格列字段。</div>
            </div>
          </div>

          <div style={{ display: 'flex', gap: '12px', alignItems: 'flex-start' }}>
            <div style={{ width: '36px', height: '36px', borderRadius: '8px', background: '#fff8e6', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
              <span style={{ fontSize: '18px' }}>💡</span>
            </div>
            <div>
              <div style={{ fontWeight: 600, fontSize: '14px', color: '#1a1a1a', marginBottom: '2px' }}>添加提示词</div>
              <div style={{ fontSize: '12px', color: '#666', lineHeight: '1.5' }}>点击字段上的星标，为每个字段填写相近词、详细描述，提升抽取准确率。</div>
            </div>
          </div>

          <div style={{ display: 'flex', gap: '12px', alignItems: 'flex-start' }}>
            <div style={{ width: '36px', height: '36px', borderRadius: '8px', background: '#f0fff4', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
              <span style={{ fontSize: '18px' }}>🚀</span>
            </div>
            <div>
              <div style={{ fontWeight: 600, fontSize: '14px', color: '#1a1a1a', marginBottom: '2px' }}>上传并识别</div>
              <div style={{ fontSize: '12px', color: '#666', lineHeight: '1.5' }}>上传 / 选择示例 / 输入URL，点击「再次识别」即可在右侧查看结果 Request、Response。</div>
            </div>
          </div>
        </div>

        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <label style={{ display: 'flex', alignItems: 'center', gap: '6px', cursor: 'pointer', fontSize: '13px', color: '#666' }}>
            <input
              type="checkbox"
              style={{ cursor: 'pointer' }}
              onChange={(e) => {
                if (e.target.checked) {
                  try { localStorage.setItem(STORAGE_KEY, 'true'); } catch { /* ignore */ }
                } else {
                  try { localStorage.removeItem(STORAGE_KEY); } catch { /* ignore */ }
                }
              }}
            />
            不再提示
          </label>
          <Button theme="primary" onClick={handleStart} style={{ minWidth: '100px' }}>
            开始体验
          </Button>
        </div>
      </div>
    </Dialog>
  );
}

export default DocExtractWelcomeDialog;
